// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"197":"bcc2288b","443":"b7efbb42","642":"e3fed465","839":"8220aa29","968":"79682bd9"}[chunkId] + ".css";
};